/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react"
import { styled, Typography, FormControl, InputAdornment, MenuItem } from "@mui/material"
import { fonts, colors } from "../../themes/dashboard/index"
import locationImage from "../../assets/images/Vector.svg"
import periodImage from "../../assets/images/Timer.svg"
import calendarImage from "../../assets/images/calendar.svg"
import { DatePicker } from 'antd'

const { RangePicker } = DatePicker;

export const DashBoardContainer = styled('div')({
  padding: '20px 20px 0px 20px',
  height: '100%',
  overflowY: 'scroll',
  overflowX: 'hidden',
  backgroundColor: '#f4f4f5',
})

export const StyledDashboardTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: '600',
  fontFamily: fonts.fontFamily,
  letterSpacing: '0px',
})

export const HeaderContainer = styled('div')({
    display: 'flex', 
    gap: '10px', 
    flexWrap: 'wrap',
    flexDirection: 'column'
})

export const dashboardFilterContainerStyles = {
  padding: 0,
  display: 'flex',
  flexDirection: {xs: 'column', md: 'row'},
  justifyContent: "flex-end",
  alignItems: { xs: "flex-start", md: "center" },
  gap: {xs: 2, md: 0},
  flex: 1,
  minWidth: 0,
  flexWrap: 'wrap',
  width: '100%'
}

export const filterContainerStyles = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  gap: { xs: 2, sm: "18px" },
  flexWrap: "wrap",
  width: { xs: "100%", md: "auto" },
  justifyContent: "flex-end",
}

export const StyledFormControl = styled(FormControl)({
  width: { xs: "100%", sm: "auto" },
  minWidth: { xs: "100%", sm: "160px" }
})

export const selectFieldStyles = {
  backgroundColor: "white",
  fontSize: "14px",
  fontFamily: fonts.fontFamily,
  "& .MuiSelect-select": { py: "6px" },
  "&.MuiOutlinedInput-root": {
    height: "40px",
    "&:hover fieldset": { borderColor: "#2b4fb9" },
    "&.Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: '#E4E4E7',
  },
  minWidth: { xs: "100%", sm: "149px" },
  borderRadius: '10px',
  padding: '8px 16px',
  fontWeight: '500',
  letterSpacing: '0px',
  color: colors?.filterTextColor
}

export const dateStyles = {
  backgroundColor: "white",
  fontSize: "14px",
  fontFamily: fonts.fontFamily,
  "& .MuiSelect-select": { py: "6px" },
  "&.MuiOutlinedInput-root": {
    height: "40px",
    "&:hover fieldset": { borderColor: "#2b4fb9" },
    "&.Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: '#E4E4E7',
  },
  minWidth: { xs: "100%", sm: "149px" },
  borderRadius: '10px',
  fontWeight: '500',
  letterSpacing: '0px',
  color: colors?.filterTextColor,
}

export const menuPropsStyles = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  autoFocus: false,
  MenuListProps: { sx: { pt: 0 } },
}

export const StyledFilterCancel = styled(InputAdornment)({
  position: 'absolute',
  right: 25,
})

export const StyledMenuItem = styled(MenuItem)({
  fontFamily: fonts.fontFamily,
  fontSize: "14px",
})

export const StyledCardContainer = styled('div')({
  display: 'flex',
  gap: '10px',
})

export const StyledRestaurantCard = styled('div')(({ backgroundColor }) => ({
  height: '40px',
  width: '40px',
  backgroundColor: backgroundColor || '#e0e0e0',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
}))

export const StyledLogo = styled('img')({
  height: '28px',
  width: '28px',
})

export const StyledFilterImage = styled('img')({
  height: '16px',
  width: '16px',
  marginTop: '-2px',
})

export const Location = () => {
  return (
    <StyledFilterImage src={locationImage} alt="Location" />
  )
}

export const Timer = () => {
  return (
    <StyledFilterImage src={periodImage} alt="timer" />
  )
}

export const arrowIconStyles = {
  marginTop: '-5px'
}

export const Calendar = () => {
  return (
    <StyledFilterImage src={calendarImage} alt="calendar" />
  )
}

export const StyledRangePicker = styled(RangePicker)`
  height: 40px;
  width: 263px;
  border-radius: 10px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  letter-spacing: 0px;
  font-weight: 500;

  &:hover {
    border-color: #2b4fb9;
  }

  &.ant-picker-focused,
  &.ot-picker-open {
    box-shadow: none;
    border-color: #2b4fb9
  }

  .ant-picker-input > input {
    font-size: 14px;
    cursor: pointer;
    font-family: ${fonts.fontFamily};
    color: ${colors.filterTextColor};
    font-weight: 500;
  }

  .ant-picker-separator {
    margin: 0 6px;
  }

  .ant-picker-prefix {
    margin-right: 6px;
    color: #6b7280;
  }
`;

export const StyledRestaurantName = styled('p')({
  fontFamily: fonts.fontFamily,
  fontSize: '14px',
  letterSpacing: '0px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})
